import { useRouter } from "next/router";
import { Language } from "../../config/LanguageConfiguration";
import { isLanguage } from "../helpers/general/isLanguage";

export const useRouterActiveLanguage = (): Language | undefined => {
  const locale = useRouter().locale;

  return isLanguage(locale) ? locale : undefined;
};
